import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";
import { Divider, Flex, Space } from "antd";

export class ProcessedSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.adminfields = [
      {
        name: "applicantName",
        label: "Customer Name (as per PAN)",
      },
      {
        name: "applicationNo",
        label: "Application No.",
        type: "text",
      },
      {
        name: "loanStatus",
        label: "Loan Status",
        type: "select",
        options: _enum.LOAN_STATUS,
      },
      {
        name: "bankName",
        label: "Bank Name",
        type: "select",
        render: (text, record) => {
          return <>{record?.bankDetails?.bankName}</>;
        },
      },
    ];

    this.overallFields = [
      {
        name: "applicantName",
        label: "Customer Name (as per PAN)",
      },
      {
        name: "applicationNo",
        label: "Application No.",
        type: "text",
      },
      {
        name: "payoutType",
        label: "Payout Type",
        type: "select",
        options: _enum.PAYOUT_TYPE,
      },
      {
        name: "bankName",
        label: "Bank Name",
        type: "select",
        render: (text, record) => {
          return <>{record?.bankDetails?.bankName}</>;
        },
      },
    ];
  }

  componentDidMount() {
    // this.getBankNames();
  }

  getBankNames = () => {
    let payload = {
      page: 1,
    };
    this.props.apis.apiGetBanknames(payload).then((data) => {
      console.log({ apiGetBanknames: data });
      let textField = this.props.isAdmin
        ? this.adminfields
        : this.overallFields;
      let bankNameField = textField.find((o) => o.name === "bankName");
      bankNameField.options = data;
      this.setState([...textField]);
    });
  };

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    let { isAdmin } = this.props;
    return (
      <div className="d-flex align-items-center justify-content-end float_top_lg-mw-1300">
        <div className="transparent_btns">
          <Flex gap="middle" align="center" justify="end" className="px-3">
            <Space size="small" split={<Divider type="vertical" />} wrap>
              <AppButton
                variant="excel"
                onClick={(e) => this.props.downloadExcel(e)}
              >
                Download Excel
              </AppButton>
              <button
                className="btn btn-sm btn-outline-secondary me-2"
                onClick={(...args) => this.props.downloadTemplateLeads(...args)}
              >
                <i className="fa fa-download me-2"></i>
                <span>Download Template</span>
              </button>
              <button
                className="btn btn-sm btn-outline-secondary me-2"
                // onClick={(e) => this.props.addBulkUploadModalFields(e)}
                ref={this.props.bulkUploadModalRef}
                // data-bs-toggle="modal"
                // data-bs-target="#bulkUploadModal"
              >
                <i className="fa fa-upload me-2"></i>
                <span>Bulk Upload</span>
              </button>
              <button
                className="btn btn-sm btn-outline-secondary me-2"
                onClick={(...args) => this.props.downloadBulkLeads(...args)}
              >
                <i className="fa fa-download me-2"></i>
                <span>Bulk Download</span>
              </button>

              <button
                type="button"
                className="btn filter_modal_btn"
                onClick={(...args) => this.toggleDrawer(...args)}
              >
                <i class="fa-solid fa-filter me-2"></i>
                <span>Filters</span>
              </button>
            </Space>
          </Flex>
        </div>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={isAdmin ? this.adminfields : this.overallFields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(ProcessedSearch);
